import qs from 'qs';
import { getBaseURL } from './http';

const SSE_DONE_MESSAGE = '[DONE]';

export async function readSSELastJson(path, { headers = {}, credentials = 'include' } = {}) {
  let lastEvent = null;

  await readSSEJsonStream(path, {
    headers,
    credentials,
    onEvent: (data) => {
      lastEvent = data;
    }
  });

  return lastEvent || { status: 'failed', response: 'invalidStreamData' };
}
// `params` as get() takes them — same serialiser, so undefined values are left out.
export async function readSSEJsonStream(path, { onEvent, params, headers = {}, credentials = 'include' } = {}) {
  const baseURL = getBaseURL().replace(/\/$/, '');
  const query = qs.stringify(params);
  const response = await fetch(`${baseURL}${path}${query ? `?${query}` : ''}`, {
    method: 'GET',
    headers: { Accept: 'text/event-stream', ...headers },
    credentials
  });

  if (!response.ok || !response.body) {
    throw new Error('Failed to open response stream');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder('utf-8');
  let buffer = '';
  let lastEvent = null;
  let doneReading = false;

  try {
    while (!doneReading) {
      const { value, done } = (await reader.read()) || {};

      if (done) {
        doneReading = true;
        break;
      }

      buffer += decoder.decode(value, { stream: true });
      const chunks = buffer.split('\n\n');
      buffer = chunks.pop() || '';

      for (const chunk of chunks) {
        const lines = chunk.split('\n').map((l) => l.trim());
        const dataLines = lines.filter((l) => l.startsWith('data:'));
        const eventLines = lines.filter((l) => l.startsWith('event:'));

        if (!dataLines.length) continue;

        const dataStr = dataLines.map((l) => l.slice(5).trim()).join('\n');
        const eventType = eventLines[0]?.slice(6).trim() || null;

        if (dataStr === SSE_DONE_MESSAGE) {
          doneReading = true;
          break;
        }

        const eventData = parseEventData(dataStr, eventType);
        if (eventData) {
          lastEvent = eventData;
          onEvent?.(eventData);
        }
      }
    }
  } finally {
    await reader.cancel().catch(() => {});
  }

  return lastEvent || { status: 'failed', response: 'invalidStreamData' };
}

function parseEventData(dataStr, eventType) {
  try {
    const parsed = JSON.parse(dataStr);
    return eventType ? { type: eventType, data: parsed } : parsed;
  } catch {
    return eventType ? { type: eventType, data: dataStr } : null;
  }
}
